module.exports = __webpack_public_path__ + "static/media/usecase-card-3-icon.625092fc.svg";